export const subtitles = {
    "1": {
        "startTime": 6.094,
        "endTime": 12.805,
        "transcript": "[?] was saying [?]. You think it could be leukemia?",
        "translation": "[?] was saying [?]. You think it could be leukemia?"
    },
    "2": {
        "startTime": 12.811,
        "endTime": 18.545,
        "transcript": "Or, she was [?] and her skin was really dark.",
        "translation": "Or, she was [?] and her skin was really dark."
    },
    "3": {
        "startTime": 20.306,
        "endTime": 23.195,
        "transcript": "Auga-qaa assiinani?",
        "translation": "Was her blood bad?"
    },
    "4": {
        "startTime": 23.204,
        "endTime": 29.048,
        "transcript": "Augani-wa apqucia uitaluni, assiinani, assirpek'nani.",
        "translation": "Their ailment was in her blood, and it was bad."
    },
    "5": {
        "startTime": 29.056,
        "endTime": 31.589,
        "transcript": "It could be some other kind of sickness too.",
        "translation": "It could be some other kind of sickness too."
    },
    "6": {
        "startTime": 33.02,
        "endTime": 36.986,
        "transcript": "We're not enough of the story [?].",
        "translation": "We're not enough of the story [?]."
    },
    "7": {
        "startTime": 36.989,
        "endTime": 44.655,
        "transcript": "Makut-mi, [?] is that, they call them chickweed that we have growing?",
        "translation": "What about these, [?] is that, they call them chickweed that we have growing?"
    },
    "8": {
        "startTime": 44.662,
        "endTime": 49.029,
        "transcript": "It's what I was just trying to get, but we'd have to see that.",
        "translation": "It's what I was just trying to get, but we'd have to see that."
    },
    "9": {
        "startTime": 50.018,
        "endTime": 58.151,
        "transcript": "I have bag of them out in my office, but they're from Kass'aq store.",
        "translation": "I have bag of them out in my office, but they're from a Western store."
    },
    "10": {
        "startTime": 58.157,
        "endTime": 63.145,
        "transcript": "But they really like those, those kind of flowers.",
        "translation": "But they really like those, those kind of flowers."
    },
    "11": {
        "startTime": 66.706,
        "endTime": 78.506,
        "transcript": "Yeah, but my friend got that tea for me, and looks really like that.",
        "translation": "Yeah, but my friend got that tea for me, and looks really like that."
    },
    "12": {
        "startTime": 78.521,
        "endTime": 91.976,
        "transcript": "Au͡gkut-wa Lucy, atsaruat tua-i tangerciigalamegteki makut tua-i niiteng'e'rmegteggu tauna atra taringesciigalkiit cauqapiallra.",
        "translation": "Those things, Lucy, since these can't see those false chamomiles, though they hear the name, they don't know exactly what it is."
    },
    "13": {
        "startTime": 91.985,
        "endTime": 93.618,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "14": {
        "startTime": 94.911,
        "endTime": 98.188,
        "transcript": "I think they were wondering...",
        "translation": "I think they were wondering..."
    },
    "15": {
        "startTime": 98.19,
        "endTime": 103.379,
        "transcript": "Aug͡kut-wa tua-i atsaruat nunallerni naumatulriit.",
        "translation": "Those false chamomiles grow in old settlements."
    },
    "16": {
        "startTime": 103.395,
        "endTime": 105.684,
        "transcript": "Yaa, nallunricaaqai ing'um.",
        "translation": "Yes, he over there knows them."
    },
    "17": {
        "startTime": 118.395,
        "endTime": 122.151,
        "transcript": "I'm not a good translator.",
        "translation": "I'm not a good translator."
    },
    "18": {
        "startTime": 122.159,
        "endTime": 126.27,
        "transcript": "No, it's not that. Did she get sick after taking medicine?",
        "translation": "No, it's not that. Did she get sick after taking medicine?"
    },
    "19": {
        "startTime": 126.278,
        "endTime": 127.667,
        "transcript": "No, she...",
        "translation": "No, she..."
    },
    "20": {
        "startTime": 127.682,
        "endTime": 132.76,
        "transcript": "She was already sick from something in her blood. There was some disease in her blood.",
        "translation": "She was already sick from something in her blood. There was some disease in her blood."
    },
    "21": {
        "startTime": 132.774,
        "endTime": 136.696,
        "transcript": "[?] six months to a year.",
        "translation": "[?] six months to a year."
    },
    "22": {
        "startTime": 146.257,
        "endTime": 150.101,
        "transcript": "Her hair was coming out. Her skin was turning dark.",
        "translation": "Her hair was coming out. Her skin was turning dark."
    },
    "23": {
        "startTime": 150.798,
        "endTime": 153.109,
        "transcript": "Does that ring a bell?",
        "translation": "Does that ring a bell?"
    },
    "24": {
        "startTime": 153.117,
        "endTime": 156.117,
        "transcript": "And that's when she started that medicine.",
        "translation": "And that's when she started that medicine."
    },
    "25": {
        "startTime": 157.937,
        "endTime": 160.07,
        "transcript": "How long ago was this?",
        "translation": "How long ago was this?"
    },
    "26": {
        "startTime": 162.045,
        "endTime": 166.745,
        "transcript": "Qavcini allrakuni tamana pillrua?",
        "translation": "How many years did that last?"
    },
    "27": {
        "startTime": 166.758,
        "endTime": 168.569,
        "transcript": "Naulluutii?",
        "translation": "Her sickness?"
    },
    "28": {
        "startTime": 168.585,
        "endTime": 169.908,
        "transcript": "Yaa, qangvaq?",
        "translation": "Yes, [since] when?"
    },
    "29": {
        "startTime": 170.343,
        "endTime": 175.265,
        "transcript": "Maa-i-w' nutaan uksurpak, allragni-llu",
        "translation": "This past winter, and last year"
    },
    "30": {
        "startTime": 175.267,
        "endTime": 180.478,
        "transcript": "Maa-i nutaan assirtuq. Assiriuq maa-i. Ayuqucimitun ellirtuq.",
        "translation": "She's good now. She's gotten better now. She's back to normal."
    },
    "31": {
        "startTime": 180.491,
        "endTime": 181.213,
        "transcript": "Just now?",
        "translation": "Just now?"
    },
    "32": {
        "startTime": 181.224,
        "endTime": 182.38,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "33": {
        "startTime": 183.899,
        "endTime": 187.143,
        "transcript": "Cami-ll', cami [?]",
        "translation": "And what year [?]."
    },
    "34": {
        "startTime": 188.296,
        "endTime": 193.162,
        "transcript": "Allrakut maa-i, wani ayagnillruuq atam.",
        "translation": "The years now, she started here, you see."
    },
    "35": {
        "startTime": 193.17,
        "endTime": 197.826,
        "transcript": "Wani allrakumi ayagnillruuq, maa-i-llu makugni allrakugni assirluni.",
        "translation": "She started this year, and now, she's been good these two years."
    },
    "36": {
        "startTime": 197.84,
        "endTime": 199.74,
        "transcript": "Okay, must be '81. (Three years.)",
        "translation": "Okay, must be '81. (Three years.)"
    },
    "37": {
        "startTime": 200.066,
        "endTime": 204.155,
        "transcript": "Pillilria. Wiinga-w' nallulaqenka cat imkut.",
        "translation": "Probably. I don't know those [years]."
    },
    "38": {
        "startTime": 204.519,
        "endTime": 207.108,
        "transcript": "[?] daughter is healthy now?",
        "translation": "[?] daughter is healthy now?"
    },
    "39": {
        "startTime": 209.167,
        "endTime": 214.39,
        "transcript": "Three years as compared ot six months that she was [?].",
        "translation": "Three years as compared ot six months that she was [?]."
    },
    "40": {
        "startTime": 219.481,
        "endTime": 224.326,
        "transcript": "Kituullrua tauna wani, nani yungcaristem yuvrillruagu?",
        "translation": "Who was that, and where did the doctor examine her?"
    },
    "41": {
        "startTime": 224.334,
        "endTime": 232.667,
        "transcript": "Wani, maani. Ii-i, maani aulukestengqertuq, Anchorage-aamun ayalgullruluni, ayagturatullruluni.",
        "translation": "Here. Yes, she has caretakers here, and she always used to go to Anchorage."
    },
    "42": {
        "startTime": 232.685,
        "endTime": 237.573,
        "transcript": "Tamana-wa naulluutii nallunringnaqluku piyuamteggu wani.",
        "translation": "It's because we want to find out what her sickness was."
    },
    "43": {
        "startTime": 237.581,
        "endTime": 238.603,
        "transcript": "Yes.",
        "translation": "Yes."
    },
    "44": {
        "startTime": 238.612,
        "endTime": 241.446,
        "transcript": "The doctors here...",
        "translation": "The doctors here..."
    },
    "45": {
        "startTime": 241.46,
        "endTime": 249.371,
        "transcript": "Wani-llu yuungcaristengqertuq cali maa-i piani. Aulukestellra piantuq wani hospital-aami.",
        "translation": "She also has a doctor here inland. Her caretaker is inland at the hospital."
    },
    "46": {
        "startTime": 260.521,
        "endTime": 261.844,
        "transcript": "Avga.",
        "translation": "Half of it."
    },
    "47": {
        "startTime": 261.848,
        "endTime": 268.315,
        "transcript": "Cali atauciq atsaq avga-gguq [?].",
        "translation": "She said half of a berry [?]."
    },
    "48": {
        "startTime": 270.619,
        "endTime": 272.707,
        "transcript": "Break-alta tang.",
        "translation": "Let's take a break."
    },
    "49": {
        "startTime": 272.717,
        "endTime": 274.939,
        "transcript": "Arulaiqaqaalta.",
        "translation": "Let's stop for a bit."
    },
    "50": {
        "startTime": 275.902,
        "endTime": 277.591,
        "transcript": "Qamiqiqua.",
        "translation": "I have a headache."
    },
    "51": {
        "startTime": 293.284,
        "endTime": 295.907,
        "transcript": "...piaqameng aunranriqertetuut.",
        "translation": "...when they do that, they stop bleeding."
    },
    "52": {
        "startTime": 298.057,
        "endTime": 304.946,
        "transcript": "She said if they got a deep cut, they usually put Tobasco on it.",
        "translation": "She said if they got a deep cut, they usually put Tobasco on it."
    },
    "53": {
        "startTime": 304.963,
        "endTime": 309.418,
        "transcript": "Yuut nuangqelartut allakarrarmeng...",
        "translation": "People have slightly different saliva..."
    },
    "54": {
        "startTime": 309.431,
        "endTime": 311.365,
        "transcript": "...pilallrukiit.",
        "translation": "...they would do that to it."
    },
    "55": {
        "startTime": 311.373,
        "endTime": 313.74,
        "transcript": "Nalluaqa tamana.",
        "translation": "I don't know that."
    },
    "56": {
        "startTime": 313.744,
        "endTime": 315.188,
        "transcript": "She doesn't know it.",
        "translation": "She doesn't know it."
    },
    "57": {
        "startTime": 315.198,
        "endTime": 316.943,
        "transcript": "Has anybody ever heard of that?",
        "translation": "Has anybody ever heard of that?"
    },
    "58": {
        "startTime": 316.946,
        "endTime": 322.691,
        "transcript": "...if they've used anything other than [?] oil or something.",
        "translation": "...if they've used anything other than [?] oil or something."
    },
    "59": {
        "startTime": 322.703,
        "endTime": 324.192,
        "transcript": "Other than oil?",
        "translation": "Other than oil?"
    },
    "60": {
        "startTime": 324.634,
        "endTime": 327.478,
        "transcript": "I mean, what was used traditionally.",
        "translation": "I mean, what was used traditionally."
    },
    "61": {
        "startTime": 330.818,
        "endTime": 331.973,
        "transcript": "Ciuciqaqata.",
        "translation": "When they have earaches."
    },
    "62": {
        "startTime": 335.445,
        "endTime": 342.0,
        "transcript": "Ak'a-gguq tamaani ciuciqaqata canek iinruavkalallruitki?",
        "translation": "A long time ago, what remedy would they use for earaches?"
    },
    "63": {
        "startTime": 342.017,
        "endTime": 350.45,
        "transcript": "Wiinga-ll' maa-i atutuanka. Ciuciqaqata irnianka uqumek kuciqerluki iluitgun imiqerluki.",
        "translation": "I do that too now. When my children have earaches, I pour some oil and fill them inside."
    },
    "64": {
        "startTime": 352.416,
        "endTime": 355.439,
        "transcript": "Allanek-qaa atuyuitellruut wani?",
        "translation": "Would they use anything else?"
    },
    "65": {
        "startTime": 356.29,
        "endTime": 360.468,
        "transcript": "Uqunek, allanek-qaa atuyuitellruut?",
        "translation": "Oil, would they use anything else?"
    },
    "66": {
        "startTime": 360.487,
        "endTime": 365.742,
        "transcript": "Tau͡gaam, tangvalallruunga tau͡gaam ilaitni-am",
        "translation": "But I used to watch some of them"
    },
    "67": {
        "startTime": 366.143,
        "endTime": 370.799,
        "transcript": "Qavcirqunek tayim' tangvallrusia? Aarnaqluni tua-i.",
        "translation": "How many times have I watched it? It was dangerous."
    },
    "68": {
        "startTime": 370.8,
        "endTime": 377.2,
        "transcript": "Kalikaq, kalikaq makuciq imegluku waten cingikeggluku.",
        "translation": "They would roll up a piece of paper like this so that it had a sharp point."
    },
    "69": {
        "startTime": 377.218,
        "endTime": 383.24,
        "transcript": "Cingikeggluku imggaarluku, tua-i-ll' wavet ciutmun ciuciqelriim ciutiinun elliluku.",
        "translation": "After they rolled it to a sharp point, they'd put it here in the ear of the one with the earache."
    },
    "70": {
        "startTime": 383.248,
        "endTime": 391.07,
        "transcript": "Tua-i-ll' tuaggun kenermek kumarrluku. Ekualuni atrarluni nutpagluni, tua-i-ll' assiriluni.",
        "translation": "Then they'd light a fire there. It would burn down and spark, then they'd get better."
    },
    "71": {
        "startTime": 393.418,
        "endTime": 395.74,
        "transcript": "Tua-i-gguq-qaa makut atsaruaruut?",
        "translation": "So are these false chamomiles?"
    },
    "72": {
        "startTime": 395.744,
        "endTime": 399.144,
        "transcript": "Atsaruaruqapiartut tamakut.",
        "translation": "Those are absolutely false chamomiles."
    },
    "73": {
        "startTime": 408.032,
        "endTime": 411.399,
        "transcript": "Tang tamaa-i tua-i atsaruat.",
        "translation": "See, those are false chamomiles."
    },
    "74": {
        "startTime": 413.567,
        "endTime": 415.944,
        "transcript": "Camek atrumaat wani?",
        "translation": "What are they called?"
    },
    "75": {
        "startTime": 415.944,
        "endTime": 418.5,
        "transcript": "Chamomiles. Chamomile.",
        "translation": "Chamomiles. Chamomile."
    },
    "76": {
        "startTime": 418.519,
        "endTime": 420.242,
        "transcript": "Caugat-gguq?",
        "translation": "What are they?"
    },
    "77": {
        "startTime": 420.245,
        "endTime": 423.589,
        "transcript": "C-H-O-M-I-L-O-T?",
        "translation": "C-H-O-M-I-L-O-T?"
    },
    "78": {
        "startTime": 433.493,
        "endTime": 439.737,
        "transcript": "Uqurrarmek kuvlallemta (Yaa.) piat, ii-i.",
        "translation": "They're talking about how we would pour oil (Yes.), yes."
    },
    "79": {
        "startTime": 439.744,
        "endTime": 442.156,
        "transcript": "Au͡gna tua-i ciuciqellria.",
        "translation": "That one with an earache."
    },
    "80": {
        "startTime": 442.17,
        "endTime": 445.859,
        "transcript": "Atsaruat kangrit.",
        "translation": "The top parts of false chamomile."
    },
    "81": {
        "startTime": 447.144,
        "endTime": 448.777,
        "transcript": "Tangellrui.",
        "translation": "(S)he saw them."
    },
    "82": {
        "startTime": 448.78,
        "endTime": 459.147,
        "transcript": "Makut-llu tua-i, cali makut, maa-i makut napayagaat makut cuyaqsuyagaat amiit.",
        "translation": "And these, these too, the bark of the branches of these little trees."
    },
    "83": {
        "startTime": 459.161,
        "endTime": 468.156,
        "transcript": "Imkut mikelnguut ilait qanrit callartelalriit, igyaraitnek qamaken anvikluki qanrit callarrluteng.",
        "translation": "Some of those children have sores on their mouths, the sores going from their throats inside going out to their mouths."
    },
    "84": {
        "startTime": 468.174,
        "endTime": 475.808,
        "transcript": "Tua-i-ll' amiit makut qaillukuarpek'naki tua-i cuyait au͡g'arraarluki, makucit napat maa-i.",
        "translation": "Then their bark, not doing anything with them after removing their leaves, these kinds of trees here."
    },
    "85": {
        "startTime": 475.819,
        "endTime": 478.564,
        "transcript": "Piciatun napanek iinruyuitellruut.",
        "translation": "They wouldn't use just any trees for medicine."
    },
    "86": {
        "startTime": 478.566,
        "endTime": 485.266,
        "transcript": "Tau͡gaam nallunaunateng tua-i makunek canek teqlirrnarqelrianek.",
        "translation": "But it would be clear which ones, these ones that are [?]."
    },
    "87": {
        "startTime": 485.271,
        "endTime": 496.011,
        "transcript": "Atam makut amiit makut allegluki, maavet camun callalriamun-llu callakayagmun uquryalegmun ellilriani",
        "translation": "You see, after ripping off the barks from these, when they put them on sores, huge sores with pus"
    },
    "88": {
        "startTime": 496.023,
        "endTime": 499.434,
        "transcript": "Imutun peqliqatuut.",
        "translation": "They get wrinkly."
    },
    "89": {
        "startTime": 499.448,
        "endTime": 503.114,
        "transcript": "Peqliqeryaraat-qaa kemgem mat'um nallunritarci?",
        "translation": "Do you know how this flesh gets wrinkly?"
    },
    "90": {
        "startTime": 503.788,
        "endTime": 511.743,
        "transcript": "Tua-i iciw' iqairiuralriani-llu meliurturalriani unatet qaill' qaingit elliqertelalriit?",
        "translation": "You know how when you wash clothes or deal with water for a while, the skin of the hands becomes abnormal?"
    },
    "91": {
        "startTime": 511.748,
        "endTime": 519.426,
        "transcript": "Tuaten tua-i makucit agtuumataqameng imkunun callalrianun, callartellrianun.",
        "translation": "That [happens] when these are in contact with sores."
    },
    "92": {
        "startTime": 519.437,
        "endTime": 526.404,
        "transcript": "Igyariqelrianun, qanrat-llu ilua callakayalrianun makut iqmiaqurluki.",
        "translation": "For those with sore throats, and bad sores in their mouths, keep these in their mouth."
    },
    "93": {
        "startTime": 526.415,
        "endTime": 532.126,
        "transcript": "Neqnialameng cakneq tua-i qanrem ilua qaill' ayuqliriqertaqluni.",
        "translation": "Because they taste so bad, the inside of the mouth becomes different."
    },
    "94": {
        "startTime": 532.135,
        "endTime": 534.39,
        "transcript": "Iinruugut cali makut amiit.",
        "translation": "Their bark is also medicinal."
    },
    "95": {
        "startTime": 534.405,
        "endTime": 541.038,
        "transcript": "Qagaa-i naumangraata allegluki, amiit makut iluit patgulluki.",
        "translation": "Though they grow out there, rip them off, and overlap the inner parts of their bark."
    },
    "96": {
        "startTime": 541.05,
        "endTime": 547.261,
        "transcript": "Callakayiit egmianun mamtuut ak'anun naumavkenateng, callalriit.",
        "translation": "Open sores heal right away, not grow for long, sores."
    },
    "97": {
        "startTime": 547.805,
        "endTime": 551.816,
        "transcript": "Irniamta iciw' ilait callarciyulalriit qanmeggnek?",
        "translation": "You know how some of children tend to get sores in their mouths?"
    },
    "98": {
        "startTime": 551.829,
        "endTime": 555.285,
        "transcript": "Tamaa-i tamakut iinruugut-llu makut.",
        "translation": "Those are also medicinal."
    },
    "99": {
        "startTime": 555.298,
        "endTime": 564.087,
        "transcript": "Iqmiaqurtelluki, tau͡gaam nuagat iglangraatgu uitalluki igyarait cali umyuaqluki.",
        "translation": "Have them keep it in their mouths, but though they swallow their saliva, let them be, keeping their throats in mind."
    },
    "100": {
        "startTime": 564.099,
        "endTime": 567.443,
        "transcript": "Tuaten atutullruaput makut.",
        "translation": "That's how we used these."
    },
    "101": {
        "startTime": 573.528,
        "endTime": 577.373,
        "transcript": "She was talking about these kinds of bushes.",
        "translation": "She was talking about these kinds of bushes."
    },
    "102": {
        "startTime": 578.29,
        "endTime": 587.324,
        "transcript": "They could use these like I said, take out the bark, and take off the black part from the outside, and use it.",
        "translation": "They could use these like I said, take out the bark, and take off the black part from the outside, and use it."
    },
    "103": {
        "startTime": 587.679,
        "endTime": 593.079,
        "transcript": "Qaillun wani peqlirtellria mumigcugngaa Kass'atun?",
        "translation": "How can you translate ”peqlirtellria [wrinkled skin]\" into English?"
    },
    "104": {
        "startTime": 593.098,
        "endTime": 596.831,
        "transcript": "Nallu[keka]. Tua-i-wa kemek iciw' allayuqertelalria?",
        "translation": "I don't know.You know how the flesh becomes different?"
    },
    "105": {
        "startTime": 596.839,
        "endTime": 603.717,
        "transcript": "Camek-llu, makunek-ll' atam iqmikuvet tua-i qanren-llu tua-i allayuqerrluni peliqerluku.",
        "translation": "And something, you see, when you keep these in your mouth, your mouth becomes different, wrinkled."
    },
    "106": {
        "startTime": 606.592,
        "endTime": 619.059,
        "transcript": "Well, that's when it's sore inside, and it turns like that, I think. It gets wrinkled. Your mouth is sore on the inside, and it gets to the point where it's wrinkled like that.",
        "translation": "Well, that's when it's sore inside, and it turns like that, I think. It gets wrinkled. Your mouth is sore on the inside, and it gets to the point where it's wrinkled like that."
    },
    "107": {
        "startTime": 622.092,
        "endTime": 625.792,
        "transcript": "When we use those, [?].",
        "translation": "When we use those, [?]."
    },
    "108": {
        "startTime": 625.805,
        "endTime": 629.905,
        "transcript": "Peqlirnarqelluteng, I don't know how you can describe that.",
        "translation": "Peqlirnarqelluteng [Making it wrinkly], I don't know how you can describe that."
    },
    "109": {
        "startTime": 629.918,
        "endTime": 633.152,
        "transcript": "But they're kind of strong.",
        "translation": "But they're kind of strong."
    },
    "110": {
        "startTime": 633.165,
        "endTime": 638.01,
        "transcript": "When you put them in your mouth, they're bitter, and they're kind of...",
        "translation": "When you put them in your mouth, they're bitter, and they're kind of..."
    },
    "111": {
        "startTime": 638.017,
        "endTime": 641.061,
        "transcript": "...kinds for sores in the mouth.",
        "translation": "...kinds for sores in the mouth."
    },
    "112": {
        "startTime": 644.077,
        "endTime": 650.4,
        "transcript": "And you can use them anytime, even in the summertime.",
        "translation": "And you can use them anytime, even in the summertime."
    },
    "113": {
        "startTime": 655.284,
        "endTime": 663.306,
        "transcript": "When we're playing outside when I was young, we used to eat the shoots from these kinds of trees.",
        "translation": "When we're playing outside when I was young, we used to eat the shoots from these kinds of trees."
    },
    "114": {
        "startTime": 663.312,
        "endTime": 666.39,
        "transcript": "You know the leaves that are just coming out?",
        "translation": "You know the leaves that are just coming out?"
    },
    "115": {
        "startTime": 666.404,
        "endTime": 667.904,
        "transcript": "We eat those.",
        "translation": "We eat those."
    },
    "116": {
        "startTime": 667.918,
        "endTime": 673.718,
        "transcript": "And then those, there's all kind of plants that you can eat.",
        "translation": "And then those, there's all kind of plants that you can eat."
    },
    "117": {
        "startTime": 673.725,
        "endTime": 677.469,
        "transcript": "And some of the plants that are dangerous",
        "translation": "And some of the plants that are dangerous"
    },
    "118": {
        "startTime": 677.483,
        "endTime": 681.316,
        "transcript": "If you don't know them, you don't have to eat them.",
        "translation": "If you don't know them, you don't have to eat them."
    },
    "119": {
        "startTime": 682.183,
        "endTime": 687.506,
        "transcript": "But anyway, she didn't mention those. But we used to eat...",
        "translation": "But anyway, she didn't mention those. But we used to eat..."
    },
    "120": {
        "startTime": 687.519,
        "endTime": 694.141,
        "transcript": "Yuuquq. Yuuquq waniwa uitauq wani uumi kalikami.",
        "translation": "[?Yuuquq]. A yuuquq is here on this paper."
    },
    "121": {
        "startTime": 694.147,
        "endTime": 703.625,
        "transcript": "Uqumek, wangkuta Yugni iluput carritullruaput uqupiamek, imarpigmiutaat seal-at uquatnek.",
        "translation": "Oil, we Yupiit would clean out our guts with real [seal] oil, the oil of the marine animals, seals."
    },
    "122": {
        "startTime": 703.636,
        "endTime": 707.98,
        "transcript": "Iciw' tua-i uquucilalriakut imkunek?",
        "translation": "You know how we render oil from those?"
    },
    "123": {
        "startTime": 712.988,
        "endTime": 719.755,
        "transcript": "Allrakumi tang ataucirqumek iinruvkatullrukaitkut iluput carrirluki.",
        "translation": "During the year, you see, they would have us take a remedy once to clean out our guts."
    },
    "124": {
        "startTime": 725.713,
        "endTime": 732.691,
        "transcript": "Wiinga-llu atuumamallruaqa ak'anun tamana iluma carrircecaraat.",
        "translation": "I also practiced cleaning out my guys for a long time like that."
    },
    "125": {
        "startTime": 732.708,
        "endTime": 743.553,
        "transcript": "Ukaqvani-llu tayima irnialingnemkun-llu, irnialinglua arnaurrlua atularaqa tua-i, piciryaraqellruamteggu wangkuta.",
        "translation": "And as I had a lot of children recently, I would use it when I had a lot of children when I became a woman, because we practiced it."
    },
    "126": {
        "startTime": 743.557,
        "endTime": 749.846,
        "transcript": "Naulluunrilnge'rma, canrilnge'rma uksut ilaitni iinrulua.",
        "translation": "Though I wasn't sick, though nothing was wrong, I would take that remedy some winters."
    },
    "127": {
        "startTime": 749.864,
        "endTime": 755.852,
        "transcript": "Saskaq tua-i, saskaq una qukarluku uqupiamek",
        "translation": "A cup, filling a cup halfway with seal oil"
    },
    "128": {
        "startTime": 755.865,
        "endTime": 767.843,
        "transcript": "Unuakumi tupagaqamta iluvut catangvailgan, neqtangvailgan, camek imaunaku ayagnitullruarput.",
        "translation": "We would start the morning when we woke up [like that] before there was anything in our stomachs, before food, with nothing in it."
    },
    "129": {
        "startTime": 771.187,
        "endTime": 781.443,
        "transcript": "Tauna tua-i saskaq qukarluku imirluku uqumek unuakumi tua-i uigarutekluku met'ullruarput.",
        "translation": "We would fill that cup haflway with seal oil, and drink it in the morning right when we woke up."
    },
    "130": {
        "startTime": 781.454,
        "endTime": 786.754,
        "transcript": "Tua-i cakviurluta. Tua-i pegnem tua-i nangluku, aren-wa tua-i tuknian.",
        "translation": "We struggled. We'd finally finish it, oh my, because it's strong."
    },
    "131": {
        "startTime": 788.043,
        "endTime": 793.343,
        "transcript": "Tua-i-wa kitugutkengnaqluku piamteggu tuaten atutullrukvut.",
        "translation": "Since we tried to make ourselves healthier, we would have it like that."
    },
    "132": {
        "startTime": 793.344,
        "endTime": 800.822,
        "transcript": "Tua-i-llu uitaluta, wanirpak uitaqerluta.",
        "translation": "Then we'd sit still, sit still right then."
    },
    "133": {
        "startTime": 800.833,
        "endTime": 807.044,
        "transcript": "Iluvut neplingcaluni-w' tua-i assiirulluni neplingluni.",
        "translation": "Our stomachs would make sounds, get bad and make sounds."
    },
    "134": {
        "startTime": 807.244,
        "endTime": 819.744,
        "transcript": "Tua-i-ll' anaqsungamta yuqercamta, anaq teggelria anluni anarkaq.",
        "translation": "Then when we needed to defecate and went to the bathroom, a hard piece of feces from inside would come out."
    },
    "135": {
        "startTime": 828.378,
        "endTime": 830.589,
        "transcript": "Ciin-gguq carrircet'lallruitki?",
        "translation": "Why would they have them clean out?"
    },
    "136": {
        "startTime": 830.603,
        "endTime": 837.492,
        "transcript": "Tua-i-llu anumarian, anumarian tau͡gaam anaq teggelria",
        "translation": "Then when it came out, only when the hard feces came out"
    },
    "137": {
        "startTime": 837.499,
        "endTime": 845.877,
        "transcript": "Nutaan neqem mer'anek puqlamek",
        "translation": "Then warm fish broth"
    },
    "138": {
        "startTime": 848.115,
        "endTime": 854.582,
        "transcript": "Tuaken tua-i meq'aqluta neqem mer'anek taryirluku.",
        "translation": "We would take occassional drinks from that fish broth, putting salt in it."
    },
    "139": {
        "startTime": 857.34,
        "endTime": 863.818,
        "transcript": "Meq'aqluta piamta nutaan anangluta tua-i nutaan amllermek.",
        "translation": "When we occassionally drank that, we would defecate a lot."
    },
    "140": {
        "startTime": 864.44,
        "endTime": 867.596,
        "transcript": "Nutaan tua-i qamna ilu carrirluku.",
        "translation": "It would clean out our guts inside."
    },
    "141": {
        "startTime": 867.604,
        "endTime": 876.471,
        "transcript": "Tau͡gaam nereksaunata yuurqaqsaunata-llu tamana nangvianun an'arkaq qamaken kenilleq ilumteńek.",
        "translation": "But we wouldn't eat, or drink anything hot until that broth came out from our guts."
    },
    "142": {
        "startTime": 877.186,
        "endTime": 884.775,
        "transcript": "Neryuunata, yuurqayuunata-llu saayuq taq'errnaqngan, ananriqerrnaqngan.",
        "translation": "We would eat, or drink anything hot since tea makes us stop defecating."
    },
    "143": {
        "startTime": 886.407,
        "endTime": 896.229,
        "transcript": "Tamatumek tau͡gaam tua-i imarkuamek apqemteńek, neqem mer'anek, tua-i merturluta ananrirvimteńun.",
        "translation": "We would only drink what we call broth, fish broth, until we stopped defecating."
    },
    "144": {
        "startTime": 896.234,
        "endTime": 904.367,
        "transcript": "Tua-ll' imna caqerlua wiinga yuvrillruaqa qamaken ilumnek anlleq.",
        "translation": "Then one day, I examined what had come out of my guts inside."
    },
    "145": {
        "startTime": 906.981,
        "endTime": 919.525,
        "transcript": "Anarkairullua, au͡gkut kingumek anelriit teggluteng, qaill' tua-i angtaaqluteng. Ilait angluteng.",
        "translation": "I had no more feces to defecate, and the ones that came out last were hard, and were varying sizes. Some were big."
    },
    "146": {
        "startTime": 919.536,
        "endTime": 921.691,
        "transcript": "Tegqapiarluteng.",
        "translation": "They were very hard."
    },
    "147": {
        "startTime": 923.964,
        "endTime": 927.464,
        "transcript": "Amllerrluteng angluteng, ilait angluteng.",
        "translation": "A lot came out, and some were big."
    },
    "148": {
        "startTime": 927.467,
        "endTime": 935.389,
        "transcript": "Tua-i-llam tauna angelria paqnakluku muraggarmek tamaaken tegullua qupluku.",
        "translation": "Then out of curiosity for that big one, I took a stick from there and split it open."
    },
    "149": {
        "startTime": 935.4,
        "endTime": 942.678,
        "transcript": "Tua-i pisciigatqeruni qup'artuq tang maaten tuar tang ilua atsaq imna Kass'artaq.",
        "translation": "After it couldn't, it split open and I found that what was inside looked like a Western fruit [apple]."
    },
    "150": {
        "startTime": 942.69,
        "endTime": 949.69,
        "transcript": "Kass'artarnek atsanek nerlalriaci. Iluit unkut tua-i tuaten ayuqluteng.",
        "translation": "You eat Western fruits [apples]. Their inside are like that."
    },
    "151": {
        "startTime": 950.329,
        "endTime": 954.484,
        "transcript": "Tegqapiarang'e'rmi qup'uq qaterrluni ilua.",
        "translation": "Though it was very hard, it split open and the inside was white."
    },
    "152": {
        "startTime": 954.491,
        "endTime": 962.88,
        "transcript": "Atsatun tamakutun iluluni, naucetaatun imutun nerlallemcetun Kass'artartun.",
        "translation": "The inside looked like an apple, like those Western plants we eat."
    },
    "153": {
        "startTime": 962.891,
        "endTime": 968.646,
        "transcript": "Iluit tuaten teggelriit au͡gkut ayuqelliniut, ayuqelalliniut.",
        "translation": "The insides of those hard ones are apparently like that."
    },
    "154": {
        "startTime": 973.725,
        "endTime": 981.292,
        "transcript": "Wii tua-i atullemnek qanemciqurangramci, atulqenrilkenka au͡gkut iinrut ilait nitellrenka nalluanka.",
        "translation": "Though I tell you about what I used, I don't know some of those remedies that I heard of but didn't use."
    },
    "155": {
        "startTime": 981.303,
        "endTime": 987.17,
        "transcript": "Tau͡gaam tua-i piciulriamek piamci. Atullemnek piuraramci, qanruquraramci.",
        "translation": "But I told you something true. I've been telling you about what I used."
    },
    "156": {
        "startTime": 987.181,
        "endTime": 992.926,
        "transcript": "Au͡g'umek-ll' ava-i iluma carrillemni tuaten iinrulua",
        "translation": "And just now, how I cleaned out my guts by taking that remedy"
    },
    "157": {
        "startTime": 992.937,
        "endTime": 1000.515,
        "transcript": "Au͡gkut anellret teggelriit kingumek cungagceńateng, green-aaruluteng cakneq",
        "translation": "The hard ones that came out last were green, very green"
    },
    "158": {
        "startTime": 1000.532,
        "endTime": 1004.432,
        "transcript": "Qaingit-llu makut mamtuluteng.",
        "translation": "And their surfaces were hard."
    },
    "159": {
        "startTime": 1004.436,
        "endTime": 1008.669,
        "transcript": "Tamakuciq qupluku yuvrilqa ava-i qanrutkaqa.",
        "translation": "I just talked about how I split that kind open and examined it."
    },
    "160": {
        "startTime": 1011.458,
        "endTime": 1015.268,
        "transcript": "Tua-i allrakumi iluput carrirturcetetullruit.",
        "translation": "During the year, they'd always have us clean out our guts."
    },
    "161": {
        "startTime": 1015.282,
        "endTime": 1024.393,
        "transcript": "Naullunrilengramta-llu neryuumiilkartengaqamta kaigpanri'rqan iluvut, tua-i carrircetetullruit.",
        "translation": "And though we weren't sick, when we didn't want to eat and our stomachs wouldn't get hungry, they'd have us clean them out."
    },
    "162": {
        "startTime": 1024.41,
        "endTime": 1032.91,
        "transcript": "Kaigyunga'arrnaqpiartuq atam, neryunga'arrnaqpiarluni kingua erullrem, ilum carrillran.",
        "translation": "It makes you hungry, you see, it makes you want to eat after cleaning out your guts."
    },
    "163": {
        "startTime": 1040.391,
        "endTime": 1047.313,
        "transcript": "Tuaten tua-i au͡gna uquq atutullruarput wangkuta, tau͡gam kesianek piyuunaku.",
        "translation": "That's how we used that seal oil, but we wouldn't always do it."
    },
    "164": {
        "startTime": 1047.325,
        "endTime": 1054.181,
        "transcript": "Tua-i tau͡gaam allrakumi tua-i tamaa-i tuaten atutullruarput iinrukluku.",
        "translation": "But we would do that in one year as a remedy."
    },
    "165": {
        "startTime": 1071.198,
        "endTime": 1075.62,
        "transcript": "Joanna wants to take a break [?] for a while.",
        "translation": "Joanna wants to take a break [?] for a while."
    },
    "166": {
        "startTime": 1075.624,
        "endTime": 1087.236,
        "transcript": "She was saying that she used to use seal oil once a year to clean their insides, the inside of their stomachs.",
        "translation": "She was saying that she used to use seal oil once a year to clean their insides, the inside of their stomachs."
    },
    "167": {
        "startTime": 1087.245,
        "endTime": 1090.812,
        "transcript": "And they clean once a year.",
        "translation": "And they clean once a year."
    },
    "168": {
        "startTime": 1092.9,
        "endTime": 1095.567,
        "transcript": "She says she still does it now.",
        "translation": "She says she still does it now."
    },
    "169": {
        "startTime": 1095.586,
        "endTime": 1103.364,
        "transcript": "And sometimes in some winters, not every year now, but then she does it in some winters now.",
        "translation": "And sometimes in some winters, not every year now, but then she does it in some winters now."
    },
    "170": {
        "startTime": 1105.081,
        "endTime": 1108.303,
        "transcript": "She said they used to use it even when they weren't sick.",
        "translation": "She said they used to use it even when they weren't sick."
    }
};